import { BreadcrumbContext } from 'providers';
import { use, useMemo } from 'react';

const useBreadcrumb = () => {
  const { location, setLocation } = use(BreadcrumbContext);

  return useMemo(
    () => ({
      location,
      setLocation,
    }),
    [location, setLocation],
  );
};

export default useBreadcrumb;
